import { render } from "./SelectCityModal.vue?vue&type=template&id=5c877847"
import script from "./SelectCityModal.vue?vue&type=script&lang=js"
export * from "./SelectCityModal.vue?vue&type=script&lang=js"
script.render = render

export default script